import {doc,getDoc} from 'firebase/firestore';

export const creatorUsername=value=>typeof value==='string'&&value.trim()&&!/^(member|team member|unknown|you)$/i.test(value.trim())&&!value.includes('@')?value.trim():'';
export function eventCreatorName(event,team={},profile={}){
 const uid=event.createdByUid||event.creatorUid||event.authorUid;
 const member=Array.isArray(team?.members)?team.members.find(person=>person?.uid===uid):null;
 return creatorUsername(event.createdBy)||creatorUsername(profile.username)||creatorUsername(team?.memberUsernames?.[uid])||creatorUsername(member?.username)||creatorUsername(member?.name)||'Unknown creator';
}
export function calendarCreatorFields(original,uid,name){
 if(!original)return {createdByUid:uid,createdBy:creatorUsername(name)};
 const originalUid=original.createdByUid||original.creatorUid||original.authorUid||'';
 return {createdByUid:originalUid,createdBy:creatorUsername(original.createdBy)||(originalUid===uid?creatorUsername(name):'')};
}
export async function calendarActorName(db,uid,contextName,roster=[]){
 const available=creatorUsername(contextName)||creatorUsername(roster.find(person=>person.uid===uid)?.username);
 if(available)return available;
 const profile=await getDoc(doc(db,'uids',uid));
 const name=creatorUsername(profile.data()?.username);
 if(name)return name;
 const account=await getDoc(doc(db,'users',uid));
 return creatorUsername(account.data()?.username)||creatorUsername(account.data()?.displayName)||'';
}
